import { render } from "./SigninView.vue?vue&type=template&id=188e5368"
import script from "./SigninView.vue?vue&type=script&lang=js"
export * from "./SigninView.vue?vue&type=script&lang=js"

import exportComponent from "/home/streamer/htdocs/streamer.fun/resources/frontend/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__